import Unleash from '@js/plugins/unleash';

export default {
    computed: {
        hasReceiptCapillaryOrderLevel() {
            return Unleash.hasFeature('receipt_capillary_order_level');
        },
    },
};
